import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { FiAlignRight, FiXCircle, FiChevronDown } from "react-icons/fi";
import "./Navbarmenu.css";
import { useMsal } from "@azure/msal-react";
// import '/node_modules/bootstrap/dist/css/bootstrap.min.css'

const Navbarmenu = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const [isMenuSubMenu, setMenuSubMenu] = useState(false);

  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };
  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }
  const toggleSubmenu = () => {
    setMenuSubMenu(isMenuSubMenu === false ? true : false);
  };
  let boxClassSubMenu = ["sub__menus"];
  if (isMenuSubMenu) {
    boxClassSubMenu.push("sub__menus__Active");
  } else {
    boxClassSubMenu.push("");
  }

  return (
    <header className="header__middle">
      <div className="head-container">
        <div className="row-fluid">
          <div className="header__middle__menus">
            <nav className="main-nav ">
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    <FiXCircle />
                  </span>
                </>
              ) : (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    <FiAlignRight />
                  </span>
                </>
              )}
              <ul className={boxClass.join(" ")}>
                <li className="menu-item">
                  <a
                    exact
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    href="https://atc.l-tt.accenture.com/Home"
                  >
                    L&TT Home
                  </a>
                </li>
                <li className="menu-item">
                  <NavLink
                    exact
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/home`}
                  >
                    Home
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    exact
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/aboutQA`}
                  >
                    QA@L&TT
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    exact
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/QAstructure`}
                  >
                    Organization Structure
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    exact
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/ProcessFlow`}
                  >
                    Process Flow
                  </NavLink>
                </li>
                {/* <li className="menu-item">
                  <NavLink
                  exact
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/qa@lkm`}
                  >

                    QA @ LKM
                  </NavLink>
                </li> */}
                {/* <li onClick={toggleSubmenu} className="menu-item sub__menus__arrows" > <NavLink className="nav-links" to="/qa@lkm" activeClassName="is-active">QA @ LKM<span><FiChevronDown /></span> </NavLink>
                  <ul className={boxClassSubMenu.join(' ')} >
                    <li><NavLink onClick={toggleClass} activeClassName='is-active' className="nav-links" to="/LKM-QA-Functions"> LKM QA Functions </NavLink> </li>
                    <li><NavLink onClick={toggleClass} activeClassName='is-active' className="nav-links" to="/LKM-Organization"> LKM Organization</NavLink> </li>
                    <li><NavLink onClick={toggleClass} activeClassName='is-active' className="nav-links" to="/Main-Process"> LKM Main Process </NavLink> </li>
                    <li><NavLink onClick={toggleClass} activeClassName='is-active' className="nav-links" to="/LKM-Templates"> LKM Templates </NavLink> </li>
                    <li><NavLink onClick={toggleClass} activeClassName='is-active' className="nav-links" to="/LKM-External-Award"> LKM External Award </NavLink> </li>
                  </ul>
                </li> */}
                <li className="menu-item">
                  <NavLink
                    exact
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/process&Templates`}
                  >
                    Process and Templates
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    exact
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/tracks`}
                  >
                    Artifacts
                  </NavLink>
                </li>

                {/* <li className="menu-item">
                  <NavLink
                  exact
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/admin`}
                  >

                    Admin
                  </NavLink>
                </li> */}

                <li className="menu-item">
                  <NavLink
                    exact
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/audit`}
                  >
                    Audits
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    exact
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/faq`}
                  >
                    FAQs
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbarmenu;
